import bilAPI from "../api";

export const patchMyAccount = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/auth/my_account/${uuid}`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getAccounts = ({ page, page_size, name, email }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/auth/accounts/`, { params: { page, page_size, name, email } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const deleteAccount = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/auth/accounts/${uuid}/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const patchAccount = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/auth/accounts/${uuid}/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
